import {
  CLEAR_URL,
  FETCHED_URL,
  FETCHED_URLS,
  START_FETCHING_URL,
  START_FETCHING_URLS
} from '../actionTypes';

import { UrlType } from '../../types/AppTypes';

interface InitialState {
  urls: UrlType[];
  loadingUrls: boolean;
  errorUrls: any;
  messageUrls: any;
  url: any;
  tablePageSize: number;
  currentPage: number;
}

const initialState: InitialState = {
  urls: [],
  loadingUrls: false,
  errorUrls: null,
  messageUrls: null,
  url: null,
  tablePageSize: 10,
  currentPage: 1,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_FETCHING_URLS:
      return {
        ...state,
        urls: [],
        errorUrls: null,
        messageUrls: null,
        loadingUrls: true,
      };
    case FETCHED_URLS: {
      const { urls, errorUrls, messageUrls } = action.payload;
      return {
        ...state,
        urls,
        errorUrls,
        messageUrls,
        loadingUrls: false,
      };
    }
    case START_FETCHING_URL: {
      return {
        ...state,
        url: null,
        error: null,
        message: null,
        loading: true,
      };
    }
    case FETCHED_URL: {
      const { url, error, message } = action.payload;
      return {
        ...state,
        url,
        error,
        message,
        loading: false,
      };
    }
    case CLEAR_URL: {
      return {
        ...state,
        url: null,
        error: null,
        message: null,
        loading: false,
      };
    }
    default:
      return state;
  }
}
